import Calendar from '../../src/legacy/Calendar';
export default Calendar;
